import { useState, useCallback } from 'react';
import { isPalindrome, TEST_CASES } from '../algorithms/isPalindrome';

/**
 * Hook que encapsula el estado y la lógica del ejercicio isPalindrome.
 */
export function useIsPalindrome() {
  const [input, setInput] = useState('');

  const handleChange = useCallback((value) => {
    setInput(value);
  }, []);

  const isValid = input.length > 0;
  const result = isValid ? isPalindrome(input) : null;

  const testResults = TEST_CASES.map((tc) => ({
    ...tc,
    actual: isPalindrome(tc.input),
    pass: isPalindrome(tc.input) === tc.expected,
  }));

  return { input, handleChange, result, isValid, testResults };
}
